import {
	useSelectedAccount,
} from '~/contexts/SelectedAccountContext';

import {
	useTeamWebsitesDropdownQuery,
} from '~/components/app/TeamWebsitesDropdown.gql';

import useEffectiveHomeAccountId from '~/hooks/useEffectiveHomeAccountId';
import useNavigationLayout from '~/hooks/useNavigationLayout';
import usePollInterval from '~/hooks/usePollInterval';



/**
 * Returns true when the websites toggle should be hidden.
 * Only applies to new navigation: hide when the selected account has 0 websites.
 * The "No websites" label and "Add website" button remain visible via InlineWebsitesSection.
 */
function useShouldHideWebsitesToggle(): boolean {
	const [currentLayout] = useNavigationLayout();
	const { selectedAccountId } = useSelectedAccount();
	const effectiveHomeAccountId = useEffectiveHomeAccountId();

	const { data } = useTeamWebsitesDropdownQuery({
		pollInterval: usePollInterval(60000),
	});

	const accounts = data?.authenticatedSession?.accounts ?? [];
	const activeAccountId = selectedAccountId ?? effectiveHomeAccountId;

	if (currentLayout !== 'new' || !activeAccountId) {
		return false;
	}

	const account = accounts.find((a) => a.id === activeAccountId);
	const websiteCount = account ? account.websites.length : -1;

	return websiteCount === 0;
}



export default useShouldHideWebsitesToggle;
